import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

function hasPerm(perm) {
  const perms = JSON.parse(localStorage.getItem('admin_perms') || '[]')
  const isSuper = localStorage.getItem('admin_is_super') === 'true'
  return isSuper || perms.indexOf(perm) !== -1
}

const routes = [
  { path: '/login', name: 'Login', component: () => import('../views/Login.vue') },
  {
    path: '/',
    component: () => import('../views/Dashboard.vue'),
    children: [
      { path: '', redirect: 'users' },
      { path: 'users', name: 'Users', component: () => import('../views/Users.vue') },
      { path: 'users/:id', name: 'UserDetail', component: () => import('../views/UserDetail.vue') },
      { path: 'chapters', name: 'Chapters', component: () => import('../views/Chapters.vue'), meta: { perm: 'chapters:view' } },
      { path: 'items', name: 'Items', component: () => import('../views/Items.vue'), meta: { perm: 'items:view' } },
      { path: 'weapons', name: 'Weapons', component: () => import('../views/Weapons.vue'), meta: { perm: 'weapons:view' } },
      { path: 'battle-effects', name: 'BattleEffects', component: () => import('../views/BattleEffects.vue'), meta: { perm: 'weapons:view' } },
      { path: 'battle-status-effects', name: 'BattleStatusEffects', component: () => import('../views/BattleStatusEffects.vue'), meta: { perm: 'weapons:view' } },
      { path: 'armors', name: 'Armors', component: () => import('../views/Armors.vue'), meta: { perm: 'armors:view' } },
      { path: 'enemies', name: 'Enemies', component: () => import('../views/Enemies.vue'), meta: { perm: 'enemies:view' } },
      { path: 'admin-users', name: 'AdminUsers', component: () => import('../views/AdminUsers.vue'), meta: { perm: 'admin:users:view' } },
      { path: 'admin-roles', name: 'AdminRoles', component: () => import('../views/AdminRoles.vue'), meta: { perm: 'admin:roles:view' } },
      { path: 'chassis', name: 'Chassis', component: () => import('../views/Chassis.vue'), meta: { perm: 'items:view' } },
      { path: 'cdevices', name: 'CDevices', component: () => import('../views/CDevices.vue'), meta: { perm: 'items:view' } },
      { path: 'engines', name: 'Engines', component: () => import('../views/Engines.vue'), meta: { perm: 'items:view' } },
      { path: 'materials', name: 'Materials', component: () => import('../views/Materials.vue'), meta: { perm: 'items:view' } },
      { path: 'tanks', name: 'Tanks', component: () => import('../views/Tanks.vue'), meta: { perm: 'items:view' } },
      { path: 'characters', name: 'Characters', component: () => import('../views/Characters.vue'), meta: { perm: 'users:edit' } },
      { path: 'gift-codes', name: 'GiftCodes', component: () => import('../views/GiftCodes.vue') },
      { path: 'gift-boxes', name: 'GiftBoxes', component: () => import('../views/GiftBoxes.vue'), meta: { perm: 'operation:game-config:view' } },
      { path: 'signin-rewards', name: 'SigninRewards', component: () => import('../views/SigninRewards.vue') },
      { path: 'profile', name: 'Profile', component: () => import('../views/Profile.vue') },
      { path: 'system-config', name: 'SystemConfig', component: () => import('../views/SystemConfig.vue') },
      { path: 'data-analysis', name: 'DataAnalysis', component: () => import('../views/DataAnalysis.vue'), meta: { perm: 'operation:analytics:view' } },
      { path: 'ui-config', name: 'UIConfig', component: () => import('../views/UIConfig.vue'), meta: { perm: 'operation:ui-config:view' } },
      { path: 'vip-config', name: 'VipConfig', component: () => import('../views/VipConfig.vue'), meta: { perm: 'operation:ui-config:view' } },
      { path: 'payment-management', name: 'PaymentManagement', component: () => import('../views/PaymentManagement.vue'), meta: { perm: 'operation:payment:view' } },
      { path: 'mail-management', name: 'MailManagement', component: () => import('../views/MailManagement.vue'), meta: { perm: 'operation:mail:manage' } },
      { path: 'battle-config', name: 'BattleConfig', component: () => import('../views/BattleConfig.vue') },
      { path: 'world-boss-activity', name: 'WorldBossActivity', component: () => import('../views/WorldBossActivity.vue') },
      { path: 'long-term-activities', name: 'LongTermActivities', component: () => import('../views/LongTermActivities.vue') },
      { path: 'weekly-events', name: 'WeeklyEvents', component: () => import('../views/WeeklyEvents.vue'), meta: { perm: 'operation:activities:view' } },
      { path: 'cosmetics', name: 'Cosmetics', component: () => import('../views/Cosmetics.vue'), meta: { perm: 'operation:ui-config:view' } },
      { path: 'wasteland-maps', name: 'WastelandMaps', component: () => import('../views/WastelandMaps.vue'), meta: { perm: 'operation:activities:view' } },
      { path: 'alchemy-config', name: 'AlchemyConfig', component: () => import('../views/AlchemyConfig.vue'), meta: { perm: 'operation:ui-config:view' } },
      { path: 'arena-config', name: 'ArenaConfig', component: () => import('../views/ArenaConfig.vue'), meta: { perm: 'operation:arena-config:view' } },
      { path: 'equipment-evolution', name: 'EquipmentEvolution', component: () => import('../views/EquipmentEvolution.vue'), meta: { perm: 'items:view' } }
    ]
  }
]

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  if (to.path !== '/login' && !token) { next('/login'); return; }
  if (to.path === '/login' && token) { next('/users'); return; }

  if (to.meta && to.meta.perm) {
    if (!hasPerm(to.meta.perm)) {
      next('/users'); return;
    }
  }
  next();
})

export default router
